import { AddCircle , Dashboard, Home, Paid, EmojiPeople, SettingsApplications, Assessment, Numbers, Doorbell, Checklist } from '@mui/icons-material';
import { ChartBar, ChartScatter, Check, LayoutDashboard, Receipt, Ticket, Trophy } from 'lucide-react';
export const PAGES = [
  {
    name: "Cuentas",
    url: "/accounts",
    icon: (
      <ChartBar fontSize="medium" />
    ),
    availableProfiles: ["superadmin", "operator"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Rifas",
    url: "/raffles",
    icon: (
      <Ticket fontSize="medium" />
    ),
    availableProfiles: ["superadmin", "operator"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: (
      <LayoutDashboard fontSize="medium" />
    ),
    availableProfiles: ["admin", "lite-admin"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Trabajo pendiente",
    url: "/pendingWork",
    icon: (
      <Checklist fontSize="medium" />
    ),
    availableProfiles: ["admin", "support", "lite-admin"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Verificación",
    url: "/purchaseOrders",
    icon: (
      <Check fontSize="medium" />
    ),
    availableProfiles: ["admin", "support", "lite-admin"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Compradores",
    url: "/purchasers",
    icon: (
      <EmojiPeople fontSize="medium" />
    ),
    availableProfiles: ["admin", "support", "lite-admin"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Ganadores",
    url: "/winners",
    icon: (
      <Trophy fontSize="medium" />
    ),
    availableProfiles: ["admin", "lite-admin", "support"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Números",
    url: "/soldTickets",
    icon: (
      <Numbers fontSize="medium" />
    ),
    availableProfiles: ["admin", "lite-admin"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Funciones💥",
    url: "/configuration",
    icon: (
      <SettingsApplications fontSize="medium" />
    ),
    availableProfiles: ["admin"],
    renderOnMobile: true,
    ownerFuncionality: false,
  },
  {
    name: "Reportes",
    url: "/reports",
    icon: (
      <Assessment fontSize="medium" />
    ),
    availableProfiles: ["admin", "lite-admin"],
    renderOnMobile: false,
    ownerFuncionality: false,
  },
  {
    name: "Reporte Facturación",
    url: "/reporte-facturacion",
    icon: (
      <Receipt fontSize="medium" />
    ),
    availableProfiles: ["operator"],
    renderOnMobile: false,
    ownerFuncionality: false,
  },
  {
    name: "Crear rifa",
    url: "/create",
    icon: (
      <AddCircle fontSize="medium" />
    ),
    availableProfiles: ["admin", "lite-admin"],
    renderOnMobile: false,
    ownerFuncionality: true,
  },
];